export const Wallet = ({ width = '26', height = '23' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3846 4.23295V1.05113H2.53036C1.66316 1.05113 1 1.94204 1 2.86931"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M23.1143 16.1756V21.0512H2.54286C1.66857 21.0512 1 20.3084 1 19.3369V3.03275C1 4.00417 1.66857 4.74703 2.54286 4.74703H23.1143V8.9375"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6431 9.82639C14.9717 9.82639 13.8574 11.2232 13.8574 13.001C13.8574 14.7788 14.9717 16.1756 16.6431 16.1756H23.3289C24.276 16.1756 25.0003 15.3502 25.0003 14.2708V9.19147C25.0003 8.81052 24.7774 8.55655 24.4431 8.55655H23.886C23.886 9.25496 23.2732 9.82639 22.7717 9.82639H21.1003H16.6431Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6924 12.8693H18.4067"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
